import { render, staticRenderFns } from "./UnconfirmedEmail.vue?vue&type=template&id=5fc91b9c&"
import script from "./UnconfirmedEmail.vue?vue&type=script&lang=js&"
export * from "./UnconfirmedEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports